import React, { useState } from 'react';

import {
  ListSubheader,
  ListItemSecondaryAction,
  List,
  ListItem,
  ListItemText,
  Input,
  ListItemIcon,
  Checkbox,
} from '@material-ui/core';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

const FacetList = ({
  title,
  items,
  limit,
  showMore,
  showMoreLimit,
  refine,
  searchForItems,
  enableCheckbox,
  isFromSearch,
  searchable,
  createURL,
}) => {
  const [extended, setExtended] = React.useState(false);
  const [searchQuery, setSearchQuery] = useState(null);
  const getLimit = () => {
    return extended ? showMoreLimit : limit;
  };

  const renderShowMore = () => {
    const disabled = limit >= items.length;
    if (!showMore) {
      return null;
    }
    if (disabled) return null;
    return (
      <ListItem
        style={{ paddingTop: 0, paddingBottom: 0, fontSize: 12 }}
        onClick={e => {
          e.preventDefault();
          setExtended(!extended);
        }}
      >
        {extended ? 'Show Less' : 'Show More'}
      </ListItem>
    );
  };

  const renderSearchBox = () => {
    if (items.length < limit && !searchQuery) return null;
    return (
      <React.Fragment>
        <Input
          placeholder={`Search ${title}`}
          onChange={event => {
            setSearchQuery(event.currentTarget.value);
            searchForItems(event.currentTarget.value);
          }}
          margin="dense"
          style={{ marginLeft: 16 }}
        />
      </React.Fragment>
    );
  };
  const renderCheckbox = item => (
    <ListItemIcon>
      <Checkbox
        checked={item ? item.isRefined : 0}
        style={{ padding: 0, paddingBottom: 0 }}
        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
        checkedIcon={<CheckBoxIcon fontSize="small" />}
        onCheck={e => {
          e.preventDefault();
          refine(item.value);
        }}
      />
    </ListItemIcon>
  );

  const searchBox = searchable ? renderSearchBox() : null;

  return (
    <List>
      <ListSubheader
        style={{
          fontSize: 18,
          paddingTop: 0,
          paddingBottom: 0,
          backgroundColor: 'white',
        }}
      >
        {title}
      </ListSubheader>
      {searchBox}
      {items.slice(0, getLimit()).map((item, idx) => (
        <ListItem
          key={idx}
          selected={item.isRefined}
          onClick={e => {
            e.preventDefault();
            refine(item.value);
          }}
          style={{ paddingTop: 0, paddingBottom: 0 }}
        >
          {enableCheckbox ? renderCheckbox(item) : null}
          <ListItemText
            primary={item.label}
            style={item.isRefined ? { fontWeight: 700 } : {}}
          />
          <ListItemSecondaryAction style={{ fontSize: 10 }}>
            ({item.count})
          </ListItemSecondaryAction>
        </ListItem>
      ))}
      {renderShowMore()}
    </List>
  );
};

export default FacetList;



// WEBPACK FOOTER //
// ./src/components/Algolia/FacetList.js